// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1eaf949b","845":"9909c752"}[chunkId] + ".chunk.js";
};